import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query, queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import PagesSpaceIdQuery from './hooks/__generated__/PagesSpaceIdQuery.graphql.ts';
import SpacePagesPersistenceQuery from './__generated__/SpacePagesPersistenceQueriesQuery.graphql.ts';
import type { PreloadSpacePagesOptions } from './types.ts';
import SearchResultsAGGSearchQuery from './__generated__/SearchResultsAGGSearchQuery.graphql.ts';
import type {
	SearchResultsAGGSearchQuery as SearchResultsAGGSearchQuery$data,
	SearchResultsAGGSearchQueryVariables as SearchResultsAGGSearchQuery$variables,
} from './__types__/SearchResultsAGGSearchQuery.ts';
import { getPreloadAggSpacePagesQueryVariables } from './utils/queryUtils.ts';
import type { GraphQLError } from 'graphql';

export const preloadSpacePages = (
	options: PreloadSpacePagesOptions,
): Promise<
	| void
	| Error[]
	| {
			data: unknown;
			errors?: ReadonlyArray<GraphQLError>;
			hasErrors: boolean;
	  }[]
> => {
	const variables = getPreloadAggSpacePagesQueryVariables(options);
	const { spaceKey, isLoggedIn, spaceId = '' } = options;
	return waitForAllReturnWhenError([
		queryAgg<SearchResultsAGGSearchQuery$data, SearchResultsAGGSearchQuery$variables>({
			query: SearchResultsAGGSearchQuery,
			variables,
		}),
		...(!spaceId
			? [
					query({
						query: PagesSpaceIdQuery,
						variables: { spaceKey },
					}),
				]
			: []),
		...(isLoggedIn
			? [
					query({
						query: SpacePagesPersistenceQuery,
						variables: { spaceKey },
					}),
				]
			: []),
	]);
};
